module.exports = __webpack_public_path__ + "img/nrl-small.68285356.png";